import React from 'react';

import { ROOT } from '@shared/helpers/routes';
import NotFound from '@shared/pages/NotFound';

export default () => {
  return <NotFound home={ROOT}></NotFound>;
};
